import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs'
import { ApiService } from './../../services/api.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

@Component({
  selector: 'app-private-lessons',
  templateUrl: './private-lessons.component.html',
  styleUrls: ['./private-lessons.component.css']
})
export class PrivateLessonsComponent implements OnInit {
  private subscriptions: Subscription = new Subscription();
  scheduleForm: FormGroup;
  sentEmail: boolean = false;

  constructor(private formBuilder: FormBuilder, private api: ApiService) {
  	this.formConstructor();
  }

  ngOnInit() {
  	document.getElementsByClassName('private-lessons')[0].classList.add('selected-text');
    
    // Main background image blur up
    let placeholder = document.getElementsByClassName('placeholder')[0];
    let small = document.getElementsByClassName('img-blurry')[0];
    let large = document.getElementsByClassName('img-large')[0];

    // 1: load small image and show it
    let img = new Image();
    img.src = small.getAttribute('src');
    img.onload = function () {
     small.classList.add('loaded');
    };
    
    // 2: load large image
    let imgLarge = new Image();
    imgLarge.src = placeholder.getAttribute('data-large'); 
    imgLarge.onload = function () {
      setTimeout(() => {
        large.classList.add('loaded');
      }, 250);
    };
  }

  // Form Constructor
  formConstructor() {
  	this.scheduleForm = this.formBuilder.group({
  		firstName: ['', [Validators.required, Validators.minLength(2), Validators.pattern('^[a-zA-Z ]*')]],
  		lastName: ['', [Validators.required, Validators.minLength(2), Validators.pattern('^[a-zA-Z ]*')]],
  		email: ['', [Validators.required, Validators.email]],
      phoneNumber: ['', [Validators.pattern('^[0-9]{3}-[0-9]{3}-[0-9]{4}$'), Validators.required]],
  		comments: ['', [Validators.required]],
  	})
  }

  // Used in Error Validations
  get myForm() {
    return this.scheduleForm.controls;
  }

  // Send email for private lessons
  sendEmail() {
  	if (this.scheduleForm.valid && !this.sentEmail) {
      this.sentEmail = true; 

      this.subscriptions.add(
        this.api.scheduleTraining(this.scheduleForm.value).subscribe()
      )

      // Hides all the inputs. 
      document.getElementsByClassName('form-inputs-container')[0].setAttribute('style', 'display: none;');
      document.getElementsByClassName('submit-container')[0].setAttribute('style', 'display: none;');

      // Decorates the title.
      document.getElementsByClassName('title')[0].innerHTML = "WE'LL CONTACT YOU SOON";
    }

  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
}
